import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import {
  acLineLossActualPrAction,
  GHIGTIAction,
  netContractualEnergyShortfallAction,
} from "../../actions/energyAction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ForecastedPR from "./ForecastedPR";
import {
  forecastingAcLineLossAction,
  forecastingPlantAvailabilityAction,
  forecastingPlantAvailabilityAction2,
  forecastingPrAction,
} from "../../actions/predictiveAction";
import ForecastedAcLineLoss from "./ForecastedAcLineLoss";
import ForecastPlantAvailability from "./ForecastPlantAvailability";
import ForecastPlantAvailability2 from "./ForecastPlantAvailability2";

const GenSummaryPred = ({ selectedLebel, scbsmbDetail, databaseStr }) => {
  const { projectDetail = {} } = useSelector((state) => state.projectDetail);

  const {
    forecastedPr = [],
    prLoading,
    forecastedAcLineLoss,
    acLineLossLoading,
    forecastedPlantAvailability,
    plantAvailabilityLoading,
    forecastedPlantAvailability2,
    plantAvailabilityLoading2

  } = useSelector((state) => state.forecasting);

  /* ###   Initialize State to animate progress bar   ### */

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    if (selectedLebel?.endTimestamp && databaseStr) {
      dispatch(forecastingPrAction(selectedLebel, databaseStr));
      dispatch(forecastingAcLineLossAction(selectedLebel, databaseStr));
      dispatch(forecastingPlantAvailabilityAction(selectedLebel, databaseStr));
      dispatch(forecastingPlantAvailabilityAction2(selectedLebel, databaseStr));
    
    }
  }, [
    dispatch,
    selectedLebel?.endTimestamp,
    selectedLebel?.startTimestamp,
    databaseStr,
  ]);

  useEffect(() => {
    if (databaseStr) {
      dispatch(forecastingPrAction({ dateRangeType: "month" }, databaseStr));
      dispatch(forecastingAcLineLossAction(selectedLebel, databaseStr));
      dispatch(forecastingPlantAvailabilityAction(selectedLebel, databaseStr));
      dispatch(forecastingPlantAvailabilityAction2(selectedLebel, databaseStr));
    }
  }, [location.pathname, databaseStr, dispatch]);
  
  return (
    <Grid container xl={12} textAlign={"center"}>
      <Grid container xl={12}>
        <Grid
          item
          xl={11.8}
          lg={11.8}
          md={11.8}
          sm={11.8}
          xs={11.8}
          // borderRadius={"14px"}
          style={{
            background:
              "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
            margin: "0 auto 0.5vmax",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.5vmax",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "white",
              padding: "0.5vmax 0.5vmax",
              position: "relative",
              overflow: "auto",
            }}
          >
            <ForecastedPR forecastedPr={forecastedPr} loading={prLoading} />
          </Grid>
        </Grid>
        {/* ###   GenOverview Container 6 end ### */}
      </Grid>

      <Grid container xl={12}>
        <Grid
          item
          xl={11.8}
          lg={11.8}
          md={11.8}
          sm={11.8}
          xs={11.8}
          // borderRadius={"14px"}
          style={{
            background:
              "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
            margin: "0 auto 0.5vmax",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.5vmax",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "white",
              padding: "0.5vmax 0.5vmax",
              position: "relative",
              overflow: "auto",
            }}
          >
            <ForecastedAcLineLoss
              forecastedAcLineLoss={forecastedAcLineLoss}
              loading={acLineLossLoading}
            />
          </Grid>
        </Grid>
        {/* ###   GenOverview Container 6 end ### */}
      </Grid>

        <Grid container xl={12}>
        <Grid
          item
          xl={11.8}
          lg={11.8}
          md={11.8}
          sm={11.8}
          xs={11.8}
          // borderRadius={"14px"}
          style={{
            background:
              "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
            margin: "0 auto 0.5vmax",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.5vmax",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "white",
              padding: "0.5vmax 0.5vmax",
              position: "relative",
              overflow: "auto",
            }}
          >
            <ForecastPlantAvailability
            forecastedPlantAvailability={forecastedPlantAvailability}
            loading={plantAvailabilityLoading}
            />

          </Grid>
          </Grid>
          </Grid>



           <Grid container xl={12}>
        <Grid
          item
          xl={11.8}
          lg={11.8}
          md={11.8}
          sm={11.8}
          xs={11.8}
          // borderRadius={"14px"}
          style={{
            background:
              "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
            margin: "0 auto 0.5vmax",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.5vmax",
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "white",
              padding: "0.5vmax 0.5vmax",
              position: "relative",
              overflow: "auto",
            }}
          >
            <ForecastPlantAvailability2
            forecastedPlantAvailability={forecastedPlantAvailability2}
            loading={plantAvailabilityLoading2}
            />

          </Grid>
          </Grid>
          </Grid>
    </Grid>
  );
};

export default GenSummaryPred;
